export default {"src":"/_next/static/media/berry-load.e35e8c84.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};